<script setup lang="ts">
    const chatbotLoaded = useState<boolean>('loadedChatBot', () => false);
    const { stickyContactConfig, uuid } = useStickyContact();
</script>

<template>
    <div
        class="sticky-wrapper"
        :class="{ '--chatbot-offset': chatbotLoaded }"
    >
        <BackToTop />
        <StoryblokComponent
            v-if="stickyContactConfig && uuid"
            :blok="stickyContactConfig"
            :uuid="uuid"
        />
    </div>
</template>

<style scoped lang="scss">
    .sticky-wrapper {
        display: flex;
        flex-direction: column;
        gap: $spacing--05;
        position: fixed;
        z-index: 40;
        right: $spacing--2;
        bottom: $spacing--2;

        &.--chatbot-offset {
            bottom: calc($spacing--4 + $spacing--2);
            right: calc($spacing--2 + 6px);
        }
    }
</style>
